import request from '@/utils/request'
// import qs from 'qs'

// 分页查看所有文档
export const docList = (postData) => {
  return request({
    url: '/back/instructions/pageList',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据id删除文档
export const deleteDoc = (postData) => {
  return request({
    url: '/back/instructions/delete',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 修改文档
export const updateDoc = (postData) => {
  return request({
    url: '/back/instructions/updateDocument',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增文档
export const addDoc = (postData) => {
  return request({
    url: '/back/instructions/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 回显文档
export const docInfos = (postData) => {
  return request({
    url: '/back/instructions/getDocument',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 修改附件
export const uploadPhoto = (postData) => {
  return request({
    url: '/back/instructions/uploadPhoto',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看分类列表
export const classifyList = (getData) => {
  return request({
    url: '/back/classification/queryList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 删除分类
export const deleteClassify = (getData) => {
  return request({
    url: '/back/classification/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 新增分类
export const saveClassify = (postData) => {
  return request({
    url: '/back/classification/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 修改分类
export const updateClassify = (postData) => {
  return request({
    url: '/back/classification/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 保存分类标签
export const saveTag = (postData) => {
  return request({
    url: '/classification-relation/saveBatch',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 删除分类标签
export const deleteTag = (postData) => {
  return request({
    url: '/classification-relation/delete',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
